import StatusConstants from '../constants/StatusConstants';

export const close = () => {
  return (dispatch) => {
    dispatch({ type: StatusConstants.MENU_STATUS_REMOVE });
  }
};



// WEBPACK FOOTER //
// ./modules/menu/actions/MenuStatusActions.js